export class FetchInstance {
  token = ''
  baseURL = ''

  setToken(token: string) {
    this.token = token
  }

  setBaseURL(baseURL: string) {
    this.baseURL = baseURL
  }

  async get<T>(url: string) {
    const options = {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${this.token}`,
        'Accept-Encoding': 'gzip, deflate, br',
      },
    }

    try {
      const res = await fetch(`${this.baseURL}${url}`, options)

      if (!res.ok) {
        throw new Error(`HTTP Error: ${res.status} - ${res.statusText}`)
      }

      return await res.json() as T
    }
    catch (error) {
      console.error(`Error during GET request to ${url}:`, error)
      throw error
    }
  }

  async post<T>(url: string, payload: any, signal?: AbortSignal) {
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.token}`,
        'Accept-Encoding': 'gzip, deflate, br',
      },
      body: JSON.stringify(payload),
      signal,
    }

    try {
      const res = await fetch(`${this.baseURL}${url}`, options)

      if (!res.ok) {
        throw new Error(`HTTP Error: ${res.status} - ${res.statusText}`)
      }

      return await res.json() as T
    }
    catch (error) {
      console.error(`Error during POST request to ${url}:`, error)
      throw error
    }
  }

  async* getNDJson(url: string, filters: any[] = []) {
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.token}`,
        'Accept': 'application/x-ndjson',
        'Connection': 'keep-alive',
        'Accept-Encoding': 'gzip, deflate, br',
      },
      body: JSON.stringify({ filters }),
    }

    let reader: ReadableStreamDefaultReader<Uint8Array> | undefined
    try {
      const response = await fetch(`${this.baseURL}${url}`, options)

      if (!response.ok) {
        throw new Error(`HTTP Error: ${response.status} - ${response.statusText}`)
      }

      reader = response.body?.getReader()
      if (!reader) {
        throw new Error('Readable stream not available in response body')
      }

      for await (const record of readableStream(reader)) {
        yield record
      }
    }
    catch (error) {
      console.error(`Error during NDJSON request to ${url}:`, error)
      throw error
    }
    finally {
      reader?.releaseLock()
    }
  }
}

async function* readableStream(reader: ReadableStreamDefaultReader) {
  let runningText = ''
  const decoder = new TextDecoder('utf-8')

  while (true) {
    const { done, value } = await reader.read()
    if (done) { break }

    const text = decoder.decode(value, { stream: true })
    const objects = text.split('\n')

    for (const obj of objects) {
      runningText += obj

      try {
        const result = JSON.parse(runningText)
        yield result
        runningText = ''
      }
      catch {
        // If parsing fails, wait for more data
      }
    }
  }
}
